// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1___8db60a0379ec940f5a9{/*!*/}.CoreXNav-cls2___987e2000be238d91e1a{display:flex;align-items:center;max-width:704px;flex:1 0;grid-gap:16px;gap:16px}.CoreXNav-cls2___987e2000be238d91e1a>*{margin:0;white-space:nowrap}.CoreXNav-cls2___987e2000be238d91e1a>*>*{white-space:normal;white-space:initial}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1___8db60a0379ec940f5a9",
	"cls2": "CoreXNav-cls2___987e2000be238d91e1a CoreXNav-cls1___8db60a0379ec940f5a9"
};
export default ___CSS_LOADER_EXPORT___;
